export enum EReservationSettingsTrigger {
  checkIn = 'check_in',
  checkOut = 'check_out',
  bookedDay = 'booked_day',
}
